const COMBINED_NAMES_IDENTIFIERS = [' and ', ' or ', '&', '/', '+', '|', '_', '-'];

export const detectCombinedNames = (name: string): boolean => {
  if (!name) return false;
  const lowerCaseName = name.toLowerCase();
  return COMBINED_NAMES_IDENTIFIERS.some((identifier) => lowerCaseName.includes(identifier));
};
